export const MAX_LENGTH_VALIDATOR_ERROR = 'maxlength';
